import { useEffect, useState } from "react";
import { compose } from "redux";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import { KeyboardDatePicker } from "@material-ui/pickers/DatePicker";

import { moneyFormater } from "../../../../utilities/formaters";
import RefreshButton from "../../../../shared/ui/Refresh.Button";

import { accountBalanceConnector } from "../../../../services/menu/dashboard/account.balance.connector";

const DashboardAccountBalanceComponent = (props) => {
  const [date, setDate] = useState(null);
  const currency = props.currency;

  useEffect(() => {
    if (!props.accountBalance[currency].fetched) fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshBtnClick = () => {
    fetchData();
  };

  const fetchData = () => {
    props.fetchTrustlyAccountBalance(currency);
  };

  const handleChangeDate = (value) => setDate(value);

  const trustlyBalanceFetched =
    props.accountBalance[currency].trustlyFetched &&
    !props.accountBalance[currency].trustlyFetching;

  if (trustlyBalanceFetched) {
    return (
      <div style={{ margin: "5px" }}>
        <div style={{ textAlign: "right" }}>
          <KeyboardDatePicker
            inputVariant="outlined"
            format="YYYY-MM-DD"
            className="small-datepicker"
            label="Show Balance For"
            onChange={handleChangeDate}
            value={date}
          />
        </div>
        <RefreshButton onRefreshClick={refreshBtnClick} />
        <Card
          style={{
            width: "50%",
            whiteSpace: "normal",
            display: "inline-block",
          }}
        >
          <CardHeader title="Trustly account balances" />
          <CardContent>
            <div>
              <strong>Cash</strong>:{" "}
              {moneyFormater(
                Math.floor(props.accountBalance[currency].trustlyData * 100) /
                  100,
              )}{" "}
              {currency}
              <br />
            </div>
            Current balance at Trustly
            <br />
            (does not support time travel)
          </CardContent>
        </Card>
      </div>
    );
  }
  return <div>Loading</div>;
};

export default compose(accountBalanceConnector)(
  DashboardAccountBalanceComponent,
);
